import { useEffect } from 'react';

import { datadogRum } from '@datadog/browser-rum';

export const useRumPageView = (key: string, name: string, context?: object) => {
  useEffect(() => {
    void datadogRum.startView(name);
  }, [context, key, name]);
};
